import {
  enumElementDrawStates,
  enumHorzCentering,
  enumVertCentering,
  kfontIconName,
  kfontIconNameRegularMedium,
  kWandIcon
} from "../constants";
import { QBoxOverlay } from "./QBoxOverlay";

export class QBoxOverlay_Wand extends QBoxOverlay {
  constructor() {
    super();
    this.fDeltaDefX = 0;
    this.fDeltaDefY = 0;
    this.fVPosition = enumVertCentering.pinBottom;
    this.fHPosition = enumHorzCentering.pinRight;
    this.fShowFilterIcon = true; // mute
    this.fFilterFill = "#282727";
  }

  Init(wsMgr, showIcon) {
    this.fHeight = 50;
    this.fWidth = 50;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var chartBox = this.fChartBox;

    //Only during hover drawstate?

    var drawState = this.GetDrawState();
    var parentDrawState = this.GetParentDrawState();
    if (
      parentDrawState !== enumElementDrawStates.Hover &&
      drawState !== enumElementDrawStates.Hover
    )
      return;
    //if (this.fIsHoverTarget)
    //	console.log('HI')
    //if (drawState !== enumElementDrawStates.hover && parentDrawState !== enumElementDrawStates.hover)
    //	return
    ctx.save();

    ctx.fillStyle = "#EEEEEE";
    ctx.strokeSTyle = "#111111";
    ctx.lineJoin = "miter";
    ctx.lineCap = "square";
    ctx.lineWidth = 1;
    //TODO: Should clipRect the parent box layout or something to properly put a 'hole' in the box?
    var width = this.fOverrideWidth !== null ? this.fOverrideWidth : chartBox.GetWidth();
    var height = chartBox.GetHeight();
    var x = this.GetPositionX() - this.fDeltaDefX;
    var y = this.GetPositionY() - this.fDeltaDefY;

    var drawPad = true;
    if (drawPad) {
      ctx.beginPath();
      ctx.arc(x, y, 15, 0, 2 * Math.PI);
      ctx.fill();
      //ctx.stroke();
    }

    ctx.fillStyle = "#111111";
    ctx.font = kfontIconNameRegularMedium;
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    ctx.fillText(kWandIcon, x, y);
    ctx.restore();
  }

  DoAltRender(altCanvas) {}

  ExecuteCommand(altCanvas) {}
}
